import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { UserInactivityService } from '@/Services/monitoryInactivity/user-inactivity.service';
import { AuthService } from '@/Services/auth.service';
import { InactivityWarningModalComponent } from '@/shared/components/general/inactivity-warning-modal/inactivity-warning-modal.component';
import { LoggerService } from '@/Services/log-level.service';
import { PermissionService } from '@/Services/Permission/permission.service';
import { HomeReportComponent } from './components/home-report/home-report.component';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    InactivityWarningModalComponent,
    HomeReportComponent,
    SkeletonModule,
  ],
  template: `
    <div class="grid grid-cols-12 gap-8">
      <div class="w-full col-span-12">
        @if (showSkeleton) {
        <p-skeleton
          class="w-full h-8 my-4"
          [shape]="'rectangle'"
          [width]="'100%'"
          [height]="'2rem'"
        ></p-skeleton>
        <p-skeleton
          class="w-full h-8 my-4"
          [shape]="'rectangle'"
          [width]="'100%'"
          [height]="'2rem'"
        ></p-skeleton>
        <p-skeleton
          class="w-full h-8 my-4"
          [shape]="'rectangle'"
          [width]="'100%'"
          [height]="'2rem'"
        ></p-skeleton>
        <p-skeleton
          class="w-full h-8 my-4"
          [shape]="'rectangle'"
          [width]="'100%'"
          [height]="'2rem'"
        ></p-skeleton>
        <p-skeleton
          class="w-full h-8 my-4"
          [shape]="'rectangle'"
          [width]="'100%'"
          [height]="'2rem'"
        ></p-skeleton>
        <p-skeleton
          class="w-full h-8 my-4"
          [shape]="'rectangle'"
          [width]="'100%'"
          [height]="'2rem'"
        ></p-skeleton>
        <p-skeleton
          class="w-full h-8 my-4"
          [shape]="'rectangle'"
          [width]="'100%'"
          [height]="'2rem'"
        ></p-skeleton>
        <p-skeleton
          class="w-full h-8 my-4"
          [shape]="'rectangle'"
          [width]="'100%'"
          [height]="'2rem'"
        ></p-skeleton>
        }
        <app-home-report />
      </div>
    </div>

    <!-- Modal de advertencia de inactividad -->
    <app-inactivity-warning-modal
      [isVisible]="inactivityService.showWarningModal()"
      [remainingSeconds]="inactivityService.remainingSeconds()"
      (continue)="continueSession()"
      (close)="logout()"
    ></app-inactivity-warning-modal>
  `,
})
export class DashboardComponent implements OnInit, OnDestroy {
  private readonly authService = inject(AuthService);
  public inactivityService = inject(UserInactivityService);
  public logger = inject(LoggerService);
  public permissionService = inject(PermissionService);
  public showSkeleton = true;

  ngOnInit(): void {
    this.inactivityService.startWatching();
    // Ya no iniciamos el monitoreo aquí, ya que se hace en APP_INITIALIZER
    this.logger.debug(
      'Llamamos a startWatching() desde el Dashboard, ya que conflictó con el APP_INITIALIZER no se inicia sino esta logueado'
    );

    const permisos = [
      {
        CodPrograma: 'querylupas',
        Ejecutar: true,
        Leer: true,
        Grabar: true,
        Borrar: true,
        Editar: false,
        Consultar: false,
      },
    ];
    this.permissionService.setProgramasPermisos(permisos);

    setTimeout(() => {
      this.showSkeleton = false;
    }, 3000);
  }

  /**
   * Continuar la sesión cuando el usuario interactúa con el botón del modal
   */
  continueSession(): void {
    this.logger.debug('Usuario eligió continuar la sesión desde el Dashboard');
    this.inactivityService.continueSession();
  }

  /**
   * Cerrar sesión cuando el usuario elige cerrar sesión desde el modal
   */
  logout(): void {
    this.logger.debug(
      'Usuario eligió cerrar sesión manualmente desde el Dashboard'
    );
    this.authService.logoutStorage();
    this.inactivityService.stopWatching();
    window.location.href = '/';
  }

  ngOnDestroy(): void {
    // No es necesario detener explícitamente el monitoreo aquí
    // ya que el InactivityManagerService maneja la terminación del monitoreo
    // cuando la aplicación se destruye o cuando el usuario cierra sesión
    this.logger.debug('Dashboard destruido');
  }
}
